module.exports = __webpack_public_path__ + "img/edit_icon.dedfd7d7.svg";